module.exports = __webpack_public_path__ + "img/picture_06.9c99fb5c.png";